import React from 'react';
import useWizardFormCtx from '../ctx-provider/useWizardFormCtx';
import WizardStepContent from '../WizardStepContent';
import BtnBack from './BtnBack';
import PageButtonNext from './PageButtonNext';
import BtnHompage from './BtnHompage';

type Param = {
    nextBtnDisabled?: boolean,
    nextBtnVisible?: boolean,
    backBtnVisible?: boolean
}

const PageContentNav: React.FC<Param> = ({ nextBtnDisabled = false, nextBtnVisible = true, backBtnVisible = true }) => {
    const { wizardFormBo } = useWizardFormCtx();
    const activeStep = wizardFormBo.activeStep;

    const renderWizardButtonNext = activeStep < WizardStepContent.maxStepCount - 2;
    const renderWizardButtonBack = activeStep > 0 && activeStep < WizardStepContent.maxStepCount - 1;

    return (
        <div style={{ display: 'flex', justifyContent: 'center', height: 50 }}>
            {backBtnVisible && (renderWizardButtonBack ? <BtnBack /> : <BtnHompage />)}
            {nextBtnVisible && renderWizardButtonNext && <PageButtonNext disabled={nextBtnDisabled} />}
        </div>
    );

}

export default PageContentNav;